module.exports = __webpack_public_path__ + "img/UP14-26_F_WS_001_2048x2048.27af9d02.png";